<template>
  <div class="tree-wrap">
    <div class="project-selector">
      <el-select size="mini" style="width: 100%" v-model="jurisdictionId" filterable placeholder="选择架构" class="kuan">
        <el-option
          v-for="item in jurisdictionList"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
    </div>
    <div class="el-tree-1">
      <el-tree ref="tree" :data="data" :empty-text="emptyText" :props="defaultProps" :lazy="true" @node-click="nodeClick"></el-tree>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'erp-project',
    props: {
      api: {
        type: String,
        default() {
          return ""
        }
      }
    },
    data() {
      return {
        jurisdictionId: '',
        jurisdictionList: [],
        projectId: 0,
        building: '',
        unit: '',
        data: [],
        emptyText: '没有数据',
        defaultProps: {
          label: 'name',
          isLeaf: 'leaf',
        }
      }
    },
    created() {
      this.getJurisdiction()
      this.getProjectList()
    },
    watch: {
      jurisdictionId(val) {
        console.log("jurisdictionId:", val)
        this.getProjectListByJurisdiction(val)
      }
    },
    methods: {

      // 获得自己和自己名下的架构
      getJurisdiction() {
        this.$myhttp.get('admin/common/jurisdiction',{
        'Content-Type': 'application/json'
        }).then(backdata=>{
        	if(backdata.data.code == 200) {
        	  this.jurisdictionList = backdata.data.data
        	} else {
            this.$message.error(backdata.data.message);
        	}
        });
      },

      // 获得自己名下的所有项目
      getProjectList() {
        this.$myhttp.get('admin/common/pindex',{
          'Content-Type': 'application/json'
        }).then(backdata=>{
        	if(backdata.data.code == 200) {
            this.data = backdata.data.data.map((item) => {
              return {id: item.id, name: item.name, type: 'project'}
            })
          } else {
            this.$message.error(backdata.data.message);
          }
        });
      },

      // 根据架构获得项目
      getProjectListByJurisdiction(jurisdictionId) {
        this.$myhttp.get(`admin/common/jurisdictionPindex?jurisdiction_id=${jurisdictionId}`,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
        	if(backdata.data.code == 200) {
        	  this.data = backdata.data.data.map((item) => {
              return {id: item.id, name: item.name, type: 'project'}
            })
        	} else {
            this.$message.error(backdata.data.message);
        	}
        });
      },

      getData(node, resolve) {

        switch(node.level) {

          case 1:
            this.projectId = node.data.id
            this.$myhttp.get(`admin/common/pindexId?pindex_id=${this.projectId}`,{
              'Content-Type': 'application/json'
            }).then(backdata=>{
              if(backdata.data.code == 200) {
                resolve(backdata.data.data.map((item, index) => {
                  return {id: index, name: item.building, type: 'building'}
                }))
              } else {
                this.$message.error(backdata.data.message);
              }
            });
            break;

          case 2:
            this.building = node.data.name
            this.$myhttp.get(`admin/common/buildingUnitOrRoom?pindex_id=${this.projectId}&building=${this.building}`,{
              'Content-Type': 'application/json'
            }).then(backdata=>{
            	if(backdata.data.code == 200) {
            	  resolve(backdata.data.data.map((item, index) => {
            	    return {id: index, name: item.stutes ? item.unit : item.room, leaf: !item.stutes, type: item.stutes ? 'unit' : 'room'}
            	  }))
            	} else {
            	  this.$message.error(backdata.data.message);
            	}
            });
            break;

          case 3:
            if(node.isLeaf == false) {
              this.unit = node.data.name
              this.$myhttp.get(`admin/common/getRoot?pindex_id=${this.projectId}&building=${this.building}&unit=${this.unit}`,{
                'Content-Type': 'application/json'
              }).then(backdata=>{
              	if(backdata.data.code == 200) {
              	  resolve(backdata.data.data.map((item, index) => {
              	    return {id: item.id, name: item.room, leaf: true, type: 'room'}
              	  }))
              	} else {
              	  this.$message.error(backdata.data.message);
              	}
              });

            }

        }

      },
      nodeClick(data, node) {
        var d = {
          level: node.level,
          type: node.data.type,
          id: node.data.id,
          name: node.data.name,
          tree:nodeToList(node)
        }
        this.$emit('node-click', d)
      }
    }
  }

  function nodeToList(node) {
    let node_list=[]
    node_list[10]=node.data;
    let nodeObj=node
    for(let i=9;i>0;i--){
      nodeObj['parent']&&(nodeObj=nodeObj['parent'],node_list[i]=nodeObj.data[0]?nodeObj.data[0]:nodeObj.data);
    }
    return node_list.filter(ret=>{return ret}).splice(1)
  }
</script>

<style lang="scss">
  .el-tree-1{
    overflow-y: scroll;
    height: calc( 100vh - 220px );
    width: 100%;
  }
  .tree-wrap {
    width: 250px;
  }

  .project-selector {
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/Common/erp-project.vue